import React, { useState, useEffect, useContext, useCallback } from "react";
import axios from "../../../axios/index";
// import { Link } from 'react-router-dom';

import { UserContext } from "../../Context/UserContextProvider";

// components
import DashboardHeader from "../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../DashboardReuseAbleComponents/DashboardSideMenu";
import ShowProfileModal from "../DashboardFileManagement/CardDetail/ShowProfileModal";
import NotificationBoxs from "./NotificationBoxs";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import NotifDetailModal from "./NotifDetailModal";

// Styles
import styles from "./Notification.module.css";
import Dstyles from "../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../assets/img/DashboardICons/ArrowRounded.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomPagination from "../../CustomPagination/CustomPagination";

const Notification = () => {
  const { userToken } = useContext(UserContext);
  const [showModal, setShowModal] = useState({
    openProfile: false,
    openDetail: false,
    id: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });
  const history = useHistory();

  const [allNotif, setAllNotif] = useState();

  const getData = useCallback(async () => {
    setIsLoading(true);
    const getApiData = await axios.get("Notification/UserAllNotifications?Take=12", {
      headers: { authorization: "Bearer " + userToken },
    });
    // console.log(getApiData)
    setPage(prev => {
      return { ...prev, pageNumber: 1, pageCount: getApiData.data.data.pageCount };
    });
    setAllNotif(getApiData.data.data.data);
    setIsLoading(false);
  }, [userToken]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <>
      <ShowProfileModal
        show={showModal.openProfile}
        onHide={() =>
          setShowModal(prev => {
            return { ...prev, openProfile: false };
          })
        }
      />

      <NotifDetailModal
        show={showModal.openDetail}
        onHide={() =>
          setShowModal(prev => {
            return { ...prev, openDetail: false };
          })
        }
        id={showModal.id}
      />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`mt-3 px-0 ${styles.file_cards_container}`}>
                <DashboardHeader
                  onClick={() =>
                    setShowModal(prev => {
                      return { ...prev, openProfile: true };
                    })
                  }
                  class="px-0"
                />

                <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2" dir="rtl">
                  <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                    <a href="#" onClick={history.goBack}>
                      <img className="ms-2" src={arrowIcon} alt="icon" />
                    </a>
                    <div className={styles.text1}>اعلانات</div>
                  </div>
                </div>

                {/* Box Notification */}
                <NotificationBoxs allNotif={allNotif} setAllNotif={setAllNotif} setShowModal={setShowModal} />

                <Stack
                  className={styles.pagination}
                  spacing={1}
                  sx={{
                    direction: "ltr",
                    bottom: "0",
                    height: "85px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center !important",
                  }}>
                  <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                </Stack>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getApiData = await axios.get(`Notification/UserAllNotifications?PageId=${value}&Take=12`, {
      headers: { authorization: "Bearer " + userToken },
    });

    setPage(prev => {
      return { ...prev, pageCount: getApiData.data.data.pageCount, pageNumber: value };
    });
    setAllNotif(getApiData.data.data.data);
    setIsLoading(false);
  }
};

export default React.memo(Notification);
